// extracted by mini-css-extract-plugin
module.exports = {"container":"desktop-session-module--container--1klFL","red":"desktop-session-module--red--1p2OR"};